import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UseDeleteAttentionTaskProps = {
  eventId: number
}

export const useDeleteAttentionTask = ({
  eventId,
}: UseDeleteAttentionTaskProps): UseMutationResult<
  void,
  APIErrorResponse,
  number
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (taskId: number) =>
      client
        .delete(`plannings/events/manager/attention-tasks/${taskId}/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          QUERY_KEYS.ATTENTION_TASKS,
          eventId,
        ])
      },
    }
  )
}
